export const SHOW_TIPS_LINK = process.env.VUE_APP_SHOW_TIPS_LINK;
export const UNDER_AGE_LINK = process.env.VUE_APP_UNDER_AGE_LINK;
export const DRINKCHAT_LINK = process.env.VUE_APP_DRINKCHAT_LINK;
export const PRIVACY_POLICY_LINK = process.env.VUE_APP_PRIVACY_POLICY_LINK;
export const TERMS_AND_CONDITIONS_LINK =
  process.env.VUE_APP_TERMS_AND_CONDITIONS_LINK;
